import { httpCall, httpFetch, httpPostData } from "../../common/util";
import axios from 'axios';
import AdminPanelActionApiMapping from "../AdminPanel/actionURLMapping";
import AppConstants from "../../config/appConstants";
import { getAuthHeaders } from "@/utils/authManager";
import { ENDPOINTS } from "@/config/apiEndpoints";
import { ACTIVITY_ENDPOINTS } from "../CreationForms/AddEditActivity/store/endpoints";
import config from '../../containers/WorkkardDetail/endpoints';
const ep = config.api.endpoints

export const fetchOrganizationProfileData = (ActionType) => {
  return httpCall({
    method: AdminPanelActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    url: AdminPanelActionApiMapping[ActionType].url
  });
};

export const updateOrgProfileName = (ActionType, payload) => {
  return httpFetch({
    url: AdminPanelActionApiMapping[ActionType].url,
    method: AdminPanelActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
  });
};

export const updateOrgProfileSubDomain = (ActionType, payload) => {
  return httpFetch({
    url: AdminPanelActionApiMapping[ActionType].url,
    method: AdminPanelActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
  });
};

export const updateOrgProfilePhone = (ActionType, payload) => {
  return httpFetch({
    url: AdminPanelActionApiMapping[ActionType].url,
    method: AdminPanelActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
  });
};

export const updateOrgProfileFax = (ActionType, payload) => {
  return httpFetch({
    url: AdminPanelActionApiMapping[ActionType].url,
    method: AdminPanelActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
  });
};

export const updateOrgProfileTimzeone = (ActionType, payload) => {
  return httpFetch({
    url: AdminPanelActionApiMapping[ActionType].url,
    method: AdminPanelActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
  });
};

export const updateBusinessLoc = (ActionType, payload) => {
  return httpFetch({
    url: AdminPanelActionApiMapping[ActionType].url,
    method: AdminPanelActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
  });
};

export const addTagForOrg = (ActionType, payload) => {
  return httpFetch({
    url: AdminPanelActionApiMapping[ActionType].url,
    method: AdminPanelActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
  });
};

export const removeTagForOrg = (ActionType, payload) => {
  return httpFetch({
    url: AdminPanelActionApiMapping[ActionType].url,
    method: AdminPanelActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
  });
};

export const getOrgLocationByZip = (payload) => {
  const {url, method} = ep.fetchDataByZip;
  return httpCall({
    method: method,
    headers: getAuthHeaders(),
    url: `${url}?q=${encodeURIComponent(payload.q)}&c=${encodeURIComponent(payload.c)}`,
  });
};

export const updateOrganizationLogo = (ActionType, payload) => {
  return httpFetch({
    url: AdminPanelActionApiMapping[ActionType].url,
    method: AdminPanelActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
  })
};

export const fetchAllSkilset = () => {
  return httpCall({
    method: AppConstants.httpMethod.GET,
    headers: getAuthHeaders(),
    url: ACTIVITY_ENDPOINTS.fetchSkillsetTags()
  });
}

export const fetchServiceLocData = (payload) => {
  const {url, method} = ep.fetchServiceLocation;
  const {queryParam, countryCode} = payload;
  return httpCall({
    method,
    headers: getAuthHeaders(),
    url: `${url}/${countryCode}?q=${queryParam}`
  });
};

export const fetchZipDataApi = (payload) => {
  const {url, method} = ep.fetchZipData;
  const {zipId, countryCode} = payload;
  return httpCall({
    method,
    headers: getAuthHeaders(),
    url: `${url}/${countryCode}?id=${zipId}`
  });
};

export const addOrRemoveServiceLocNames = (payload) => {
  const {url, method} = ep.updateOrgServiceLocationEP;
  return httpCall({
    method,
    headers: getAuthHeaders(),
    url,
    data: payload,
  });
};

export const removeOrgLogo = (ActionType, payload) => {
  return httpFetch({
    url: AdminPanelActionApiMapping[ActionType].url,
    method: AdminPanelActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
  })
};

export const fetchRelationships = (payload = {}) => {
  return httpCall({
    method: 'GET',
    params: payload,
    headers: { "Content-Type": "application/json" },
    url: '/1.0/organization/relationship',
  });
};

export const fetchActiveContracts = (id) => {
  return httpCall({
    method: 'GET',
    params: { id, type: 'ACCEPTED' },
    url: '/1.0/organization/contracts',
  });
};

//Configuration parties API
const getApiConfig = (actionType) => {
  const config = AdminPanelActionApiMapping[actionType];
  if (!config) {
    throw new Error(`Invalid action type: ${actionType}`);
  }
  return config;
};

const requestApi = (actionType, {pathSuffix = '', params, data, } = {},) => {
  const { url, method } = getApiConfig(actionType);
  return httpCall({
    method,
    url: `${url}${pathSuffix}`,
    headers: { "Content-Type": "application/json" },
    params,
    data,
  });
};

// Fetch parties
export const fetchPartiesData = (actionType, payload) =>
  requestApi(actionType, {
    params: payload,
  });

// Delete party
export const deletePartyById = (actionType, { id }) =>
  requestApi(actionType, {
    data: {
      party_ids: [id],
    },
  });

// Activate / Deactivate party
export const activateDeactivatePartyRequest = (actionType, { id, flag }) =>
  requestApi(actionType, {
    pathSuffix: `/${id}`,
    data: {
      party: {
        is_active: flag,
      },
    },
  });

// Save associated party
export const saveAssociatedParty = (actionType, payload) =>
  requestApi(actionType, {
    data: {
      party: payload,
    },
  });

// Edit associated party
export const editAssociatedParty = (actionType, { party_id, ...payload }) =>
  requestApi(actionType, {
    pathSuffix: `/${party_id}`,
    data: {
      party: payload,
    },
  });
export const fetchWorkkardTotals = (payload = {}) => {
  return httpCall({
    method: AppConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    params: payload,
    url: "/workkardtotoal",
  });
};

export const fetchActivityTotals = (payload = {}) => {
  return httpCall({
    method: AppConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    params: payload,
    url: "/activitytotal",
  });
};

export const fetchOrganisationCommunity = (payload = {}) => {
  return httpCall({
    method: AppConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    params: payload,
    url: "/1.0/organization/community",
  });
};

export const postRelationshipAccess = (payload = {}) => {
  return httpCall({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    data: payload,
    url: '/1.0/organization/relationship/access',
  });
};

export const deleteRelationshipAccess = (payload = {}) => {
  return httpCall({
    method: 'DELETE',
    headers: { "Content-Type": "application/json" },
    data: payload,
    url: '/1.0/organization/relationship/access',
  });
};

export const updateOrganizationRelationship = (payload = {}) => {
  return httpCall({
    method: 'PUT',
    headers: { "Content-Type": "application/json" },
    data: payload,
    url: '/1.0/organization/relationship',
  });
};

export const AddOrganizationRelationship = (payload = {}) => {
  return httpCall({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    data: payload,
    url: '/1.0/organization/relationship',
  });
};

export const searchOrganizations = (search_string) => {
  return httpCall({
    method: 'GET',
    headers: { "Content-Type": "application/json" },
    params: { search_string },
    url: '/1.0/organization/search',
  });
};

export const fetchPartyChangeLog = (payload = {}) => {
  return httpCall({
    method: AppConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    params: payload,
    url: "/eparLogs"
  });
};
